import TreeCollection from 'bloko/common/tree/treeCollection';
import { AdditionalDefault, IdCollectionPredicate } from 'bloko/common/tree/types';

interface Options {
    singleChoice?: boolean;
    leavesOnly?: boolean;
    checkSelectable?: IdCollectionPredicate;
    singleCategory?: boolean;
    withExcluded?: boolean;
}

export interface Iterable<T> {
    [Symbol.iterator](): Iterator<T>;
}

interface ImmutableSelectionStrategyInterface {
    new (collection: TreeCollection<AdditionalDefault>, options: Options): {
        add(items: Iterable<string>, addedItems: string[]): string[];
        exclude(items: Iterable<string>, excludedItems: string[], processedItems: string[]): string[];
        remove(items: Iterable<string>, removedItems: string[]): string[];
    };
}

declare const ImmutableSelectionStrategy: ImmutableSelectionStrategyInterface;

export default ImmutableSelectionStrategy;
